export const LINK_PATH = process.env.PUBLIC_URL;